import { useEffect, useState } from 'react'

import img from '../../Images/analyticsdashbordimage.png'
import img2 from '../../Images/Vector (26).png'
import img3 from '../../Images/Vector (27).png'
import { NavLink, useNavigate } from 'react-router-dom'
import user from '../../Images/user.png'
import smalllogo from '../../Images/Vector (4).png'
import smalllogo2 from '../../Images/Vector (5).png'
import smalllogo3 from '../../Images/Vector (6).png'
import smalllogo4 from '../../Images/Group 427319809.png'
import { formatDateAgo, formatNumberToUnits } from '../../utils/Helper';
import { useDispatch, useSelector } from 'react-redux'
import { fetchAnalyticsReportOverview } from '../../Redux/Slice/AnalyticsSlice'
import { SetDisplayUserData } from '../../Redux/Slice/PostSlice'
import defaultUserImage from '../../Images/logootherblm.png'
import HttpClient from '../../utils/HttpClient'

const AnalyticsReport = () => {
    const { AnalyticsReportOverview } = useSelector((state) => state.analytics);
    const { UserProfileID } = useSelector((state) => state.app);
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [singleData, setSingleData] = useState()
    const [activeInfoType, setActiveInfoType] = useState("account-reached")
    const [connections, setConnections] = useState([]);

    const handleBusinessPageView = (e, item) => {
        e.preventDefault()
        setSingleData(item)
        dispatch(SetDisplayUserData([item]))
        if (item?.businessStatus) {
            { item?.companySlug && (navigate(`/businesspage/${item?.companySlug}`)) }
        } else {
            { item?.userName && (navigate(`/profile/${item?.userName}`)) }
        }
    }

    const handleProfilePageView = (e, item) => {
        e.preventDefault()
        navigate(`/profile/${item?.userName}`)
    }

    const fetchConnections = async () => {
        const res = await HttpClient.requestData("member-contacts", "GET", {});
        if (res && res?.status) {
            setConnections(res?.data.length || 0);
        }
    };

    useEffect(() => {
        dispatch(fetchAnalyticsReportOverview())
        fetchConnections()
    }, [])

    return (
        <>
            <section className='membermastersection' style={{
                padding: '10px 0px'
            }}>
                <div className="cust_container">
                    <div className='membermastersectionbg member_section_new_class' style={{

                        background: 'transparent',
                    }}>
                        <div className='left_analtics_div_wrapper'>
                            <div className='left_analtics_container'>
                                <div className='left_analtics_logo'>
                                    <div className='analytics_img_div'>
                                        <img src={img} />

                                    </div>
                                    <p>Analytics</p>
                                </div>
                                <div className='nav_link_wrapper'>
                                    <NavLink to={'/analytics-report'} className='left_analtics_links_wrapper'>
                                        <div className='left_analtics_link_img'>
                                            <img src={img2} />
                                        </div>
                                        <p>Overview</p>
                                    </NavLink>
                                    {
                                        UserProfileID?.businessStatus &&
                                        <NavLink to={'/analytics'} className='left_analtics_links_wrapper'>
                                            <div className='left_analtics_link_img'>
                                                <img src={img3} />
                                            </div>
                                            <p>My Page</p>
                                        </NavLink>
                                    }


                                    <NavLink to={'/analytics-profile'} className='left_analtics_links_wrapper'>
                                        <div className='left_analtics_link_img'>
                                            <img src={img3} />
                                        </div>
                                        <p>My Profile</p>
                                    </NavLink>
                                </div>
                                {/* <div className='nav_link_wrapper'>
                                    <div onClick={(() => setdropdown(!dropdown))} className='left_analtics_links_wrapper'>
                                        <div className='left_analtics_link_img'>
                                            <img src={img3} />
                                        </div>
                                        <p>BLM page</p>

                                        <img src={arrowup} style={{
                                            width: '22px',
                                            height: '22px',
                                            marginTop: '7px'
                                        }} />
                                    </div>
                                    {dropdown && <div className='blm_page_dropdown_div'>
                                        <p>Followers</p>
                                        <p>Public</p>
                                    </div>}

                                    <div onClick={(() => setdropdown2(!dropdown2))} className='left_analtics_links_wrapper'>
                                        <div className='left_analtics_link_img'>
                                            <img src={img3} />
                                        </div>
                                        <p>Profile</p>

                                        <img src={arrowup} style={{
                                            width: '22px',
                                            height: '22px',
                                            marginTop: '7px'
                                        }} />
                                    </div>

                                    {dropdown2 && <div className='blm_page_dropdown_div'>
                                        <p>Members</p>
                                        <p>Non Members</p>
                                    </div>}
                                </div> */}
                            </div>
                            {/* <div className='export_div_wrapper'>
                                <div className='export_div'>
                                    <div className='export_img'>
                                        <img src={img5} />
                                    </div>
                                    <p>Export</p>
                                </div>
                                <div className='lock_img_div'>
                                    <img src={img6} />
                                </div>
                            </div> */}
                        </div>
                        <div className='right_analtics_div'>
                            <div className='right_analtics_div_container'>
                                <div className='overview_wrapper'>
                                    <p>Overview</p>

                                    {/* <div className='filter_box_wrapper'>
                                        <div className='filter_box'>
                                            <img src={img7} />
                                            <p>2</p>
                                        </div>
                                        <div className='filter_box'>
                                            <img src={img8} />
                                            <span>Jan 1, 2024 - Dec 31, 2024</span>
                                        </div>
                                    </div> */}



                                </div>


                            </div>
                            <div className='account_wrapper'>
                                <div
                                    style={{ cursor: "pointer" }}
                                    className={activeInfoType === "account-reached" ? "account_1 active_class" : "account_1"}
                                    onClick={(e) => setActiveInfoType("account-reached")}
                                >
                                    <div className='account_logo_wrapper'>
                                        <div className='account_logo_div'>
                                            <img src={smalllogo} />
                                        </div>
                                        <p>Accounts Reached</p>
                                    </div>
                                    <div className='account_reached_wrapper'>
                                        <div>
                                            <h5>{formatNumberToUnits(AnalyticsReportOverview?.TotalReachedCount || 0)}</h5>
                                            {/* <h4>+8.5K this week</h4> */}
                                        </div>
                                        {/* <h6>+1.29%</h6> */}
                                    </div>
                                </div>
                                <div
                                    style={{ cursor: "pointer" }}
                                    className={activeInfoType === "account-engagement" ? "account_1 active_class" : "account_1"}
                                    onClick={(e) => setActiveInfoType("account-engagement")}
                                >
                                    <div className='account_logo_wrapper'>
                                        <div className='account_logo_div'>
                                            <img src={smalllogo2} />
                                        </div>
                                        <p>Accounts Engagement</p>
                                    </div>
                                    <div className='account_reached_wrapper'>
                                        <div>
                                            <h5>{formatNumberToUnits(AnalyticsReportOverview?.TotalEngagededCount || 0)}</h5>
                                            {/* <h4>+8.4K this week</h4> */}
                                        </div>
                                        {/* <h6 style={{
                                            background: " rgba(2, 177, 90, 0.15)"

                                        }}>+1.29%</h6> */}
                                    </div>
                                </div>
                                <div
                                    style={{ cursor: "pointer" }}
                                    className={activeInfoType === "total-likes" ? "account_1 active_class" : "account_1"}
                                    onClick={(e) => setActiveInfoType("total-likes")}
                                >
                                    <div className='account_logo_wrapper'>
                                        <div className='account_logo_div'>
                                            <img src={smalllogo3} />
                                        </div>
                                        <p>Total Likes</p>
                                    </div>
                                    <div className='account_reached_wrapper'>
                                        <div>
                                            <h5>{formatNumberToUnits(AnalyticsReportOverview?.TotalLikeCount || 0)}</h5>
                                            {/* <h4>+8.4K this week</h4> */}
                                        </div>
                                        {/* <h6 style={{
                                            background: " rgba(235, 0, 27, 0.15)"

                                        }}>+1.29%</h6> */}
                                    </div>
                                </div>
                                <div
                                    style={{ cursor: "pointer" }}
                                    className={activeInfoType === "total-members" ? "account_1 active_class" : "account_1"}
                                    onClick={(e) => setActiveInfoType("total-members")}
                                >
                                    <div className='account_logo_wrapper'>
                                        <div className='account_logo_div'>
                                            <img src={smalllogo4} />
                                        </div>
                                        <p>Total Connections</p>
                                    </div>
                                    <div className='account_reached_wrapper'>
                                        <div>
                                            {/* <h5>{formatNumberToUnits(AnalyticsReportOverview?.TotalMembersCount + AnalyticsReportOverview?.TotalNonMembersCount)}</h5> */}
                                            <h5>{connections}</h5>
                                            {/* <h4>+8.4K this week</h4> */}
                                        </div>
                                        {/* <h6 style={{
                                            background: " rgba(2, 177, 90, 0.15)"

                                        }}>+1.29%</h6> */}
                                    </div>
                                </div>
                            </div>

                            <div className='right_analtics_table_wrapper'>
                                <div className='all_actives_wrapper'>
                                    <h2>{activeInfoType === "account-reached" ? "Account Reached" : activeInfoType === "account-engagement" ? "Accounts Engagement" : activeInfoType === "total-likes" ? "Total Likes" : activeInfoType === "total-members" ? "Total Connections" : ""}</h2>
                                    <div className='select_boxes select_boxes_2'>

                                        {/* <input readOnly value={'Profile 40'} />
                                        <input readOnly value={'Page 50'} />

                                        <select>
                                            <option value={'Last 7 Days'}>Last 7 Days</option>
                                            <option value={'today'}>Today</option>
                                            <option value={'week'}>This Week</option>
                                            <option value={'month'}>This Month</option>
                                        </select> */}
                                    </div>


                                </div>
                                <div className='right_table_content_wrapper'>
                                    <table>
                                        <tbody>

                                            {/* ReachedData
                                        LikedData */}
                                            {
                                                activeInfoType === "total-likes" && (
                                                    <>
                                                        {
                                                            AnalyticsReportOverview.LikedData.map((e, i) => {
                                                                return (
                                                                    <>
                                                                        <tr key={`likedata-${i}`} style={{
                                                                            borderBottom: ' 1px solid rgba(195, 195, 195, 1)'
                                                                        }}>
                                                                            <td className='table_data_1'>
                                                                                <div className='company_logo_details_Wrappper'
                                                                                    style={{
                                                                                        cursor: "pointer"
                                                                                    }}
                                                                                    onClick={(event) => handleBusinessPageView(event, e?.likedByData)}
                                                                                >
                                                                                    <div className='logo_img656'>
                                                                                        {/* businessProfilePic */}
                                                                                        <img src={e?.likedByData?.businessStatus ? e?.likedByData?.businessProfilePic : e?.likedByData?.profilePhoto || defaultUserImage} title={e?.likedByData?.companyName} />
                                                                                    </div>
                                                                                    <div className='logo_details656'>
                                                                                        <p>{e?.likedByData?.companyName || e?.likeddByData?.personName}</p>
                                                                                        <span>{e?.likedByData?.companyTypeName}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td className='table_data_2'>
                                                                                Liked your profile
                                                                            </td>
                                                                            <td className='table_data_3'>
                                                                                {formatDateAgo(e?.createdOn)}
                                                                            </td>
                                                                            <td className='table_data_4'>
                                                                                <div>
                                                                                    <img src={user} />
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    </>
                                                                )
                                                            })
                                                        }

                                                        {
                                                            AnalyticsReportOverview.ProfileLikedData
                                                                // .sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn))
                                                                .map((e, i) => {
                                                                    return (
                                                                        <>
                                                                            <tr key={`ProfileLikedData-${i}`} style={{
                                                                                borderBottom: ' 1px solid rgba(195, 195, 195, 1)'
                                                                            }}>
                                                                                <td className='table_data_1'>
                                                                                    <div className='company_logo_details_Wrappper'
                                                                                        style={{
                                                                                            cursor: "pointer"
                                                                                        }}
                                                                                        onClick={(event) => handleProfilePageView(event, e?.likeddByData)}
                                                                                    >
                                                                                        <div className='logo_img656'>
                                                                                            {/* <img src={e?.likeddByData?.profilePhoto || defaultUserImage} title={e?.likeddByData?.personName} /> */}
                                                                                            {/* <img src={e?.likedByData?.businessStatus ? e?.likedByData?.businessProfilePic : e?.likedByData?.profilePhoto || defaultUserImage} title={e?.likedByData?.companyName} /> */}
                                                                                            <img src={e.likeddByData.profilePhoto || defaultUserImage} title={e?.likeddByData?.personName} />
                                                                                        </div>
                                                                                        <div className='logo_details656'>
                                                                                            <p>{e?.likeddByData?.personName}</p>
                                                                                            <span>{e?.likeddByData?.companyName}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                                <td className='table_data_2'>
                                                                                    Liked your profile
                                                                                </td>
                                                                                <td className='table_data_3'>
                                                                                    {formatDateAgo(e?.createdOn)}
                                                                                </td>
                                                                                <td className='table_data_4'>
                                                                                    <div>
                                                                                        <img src={user} />
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        </>
                                                                    )
                                                                })
                                                        }
                                                    </>
                                                )
                                            }
                                            {
                                                activeInfoType === "account-reached" && AnalyticsReportOverview.ReachedData.filter(item => item?.visitedBy !== UserProfileID?._id).sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn)).map((e, i) => {

                                                    return (
                                                        <>
                                                            <tr key={`ReachedData-${i}`} style={{
                                                                borderBottom: ' 1px solid rgba(195, 195, 195, 1)'
                                                            }}>
                                                                {/* <td className='table_data_1'>
                                                                    <div className='company_logo_details_Wrappper'
                                                                        style={{
                                                                            cursor: "pointer"
                                                                        }}
                                                                        onClick={(event) => handleBusinessPageView(event, e?.visitedByData)}
                                                                    >
                                                                        <div className='logo_img656'>
                                                                            <img src={e.visitedByData?.profilePhoto || e.visitedByData?.profilePhoto || defaultUserImage} title={e?.visitedByData?.personName || e?.visitedByData?.personName} />
                                                                        </div>
                                                                        <div className='logo_details656'>
                                                                            <p>{e?.visitedByData?.personName || e?.visitedByData?.personName}</p>
                                                                            {
                                                                                e?.visitedByData?.companyName || e?.visitedByData?.companyName &&
                                                                                <span>{e?.visitedByData?.companyName || e?.visitedByData?.companyName}</span>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className='table_data_2'>
                                                                    Visited your {e?.pageVisitor ? "page" : "profile1"}
                                                                </td>
                                                                <td className='table_data_3'>
                                                                    {formatDateAgo(e?.createdOn)}
                                                                </td>
                                                                <td className='table_data_4'>
                                                                    <div>
                                                                        <img src={e.visitedByData?.businessProfilePic || e.visitedByData?.businessProfilePic || user} title={e?.visitedByData?.companyName || e?.visitedByData?.companyName} alt={e?.visitedByData?.businessProfilePic || e?.visitedByData?.businessProfilePic} style={{ maxHeight: "47px" }} />
                                                                    </div>
                                                                </td> */}
                                                                {e?.pageVisitor ? (
                                                                    <>
                                                                        <td className='table_data_1'>
                                                                            <div className='company_logo_details_Wrappper' style={{ cursor: "pointer" }}
                                                                                onClick={(event) => handleBusinessPageView(event, e?.visitedByDatas)}>
                                                                                <div className='logo_img656'>
                                                                                    <img src={e.visitedByDatas?.profilePhoto || defaultUserImage} title={e?.visitedByDatas?.personName} />
                                                                                </div>
                                                                                <div className='logo_details656'>
                                                                                    <p>{e?.visitedByDatas?.personName || e?.visitedByDatas?.personName}</p>
                                                                                    {e?.visitedByDatas?.companyName &&
                                                                                        <span>{e?.visitedByDatas?.companyName}</span>
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td className='table_data_2'>
                                                                            Visited your page
                                                                        </td>
                                                                        <td className='table_data_3'>
                                                                            {formatDateAgo(e?.createdOn)}
                                                                        </td>
                                                                        <td className='table_data_4'>
                                                                            <div>
                                                                                <img src={e.visitedByDatas?.businessProfilePic || user} title={e?.visitedByDatas?.companyName} alt={e?.visitedByDatas?.businessProfilePic} style={{ maxHeight: "47px" }} />
                                                                            </div>
                                                                        </td>

                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <td className='table_data_1'>
                                                                            <div className='company_logo_details_Wrappper' style={{ cursor: "pointer" }}
                                                                                onClick={(event) => handleBusinessPageView(event, e?.visitedByData)}>
                                                                                <div className='logo_img656'>
                                                                                    <img src={e.visitedByData?.profilePhoto || defaultUserImage} title={e?.visitedByData?.personName} />
                                                                                </div>
                                                                                <div className='logo_details656'>
                                                                                    <p>{e?.visitedByData?.personName}</p>
                                                                                    {e?.visitedByData?.companyName && (<span>{e?.visitedByData?.companyName}</span>)}
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td className='table_data_2'>
                                                                            Visited your profile
                                                                        </td>
                                                                        <td className='table_data_3'>
                                                                            {formatDateAgo(e?.createdOn)}
                                                                        </td>
                                                                        <td className='table_data_4'>
                                                                            <div>
                                                                                <img src={e.visitedByData?.businessProfilePic || user} title={e?.visitedByData?.companyName} alt={e?.visitedByData?.businessProfilePic} style={{ maxHeight: "47px" }} />
                                                                            </div>
                                                                        </td>
                                                                    </>
                                                                )
                                                                }
                                                            </tr>
                                                        </>
                                                    )
                                                })
                                            }

                                            {
                                                activeInfoType === "account-engagement" && AnalyticsReportOverview.EngagededData.filter(item => item?.visitedBy !== UserProfileID?._id && item?.likedBy !== UserProfileID?._id).sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn)).map((e, i) => {

                                                    return (
                                                        <>
                                                            <tr key={`EngagededData-${i}`} style={{
                                                                borderBottom: ' 1px solid rgba(195, 195, 195, 1)'
                                                            }}>
                                                                <td className='table_data_1'>
                                                                    <div className='company_logo_details_Wrappper'
                                                                        style={{
                                                                            cursor: "pointer"
                                                                        }}
                                                                        onClick={(event) => handleBusinessPageView(event, e?.visitedByDatas || e?.visitedByData || e?.likedByData || e?.likeddByData || e?.ratingGivenByData || e?.ratingGivenByDatas || e?.pageFollowedBy || e?.followedByuser)}
                                                                    >
                                                                        <div className='logo_img656'>
                                                                            {/* <img src={e.visitedByData.businessProfilePic || defaultUserImage} title={e?.visitedByData?.companyName} alt={e?.visitedByData?.businessProfilePic} /> */}
                                                                            {/* <img src={e.visitedByData.businessStatus ? e.visitedByData.businessProfilePic : e.visitedByData.profilePhoto || defaultUserImage} title={e?.visitedByData?.companyName} /> */}
                                                                            <img src={e.visitedByData?.profilePhoto || e.visitedByDatas?.profilePhoto || e.likedByData?.profilePhoto || e.likeddByData?.profilePhoto || e.ratingGivenByData?.profilePhoto || e.ratingGivenByDatas?.profilePhoto || e.pageFollowedBy?.profilePhoto || e.followedByuser?.profilePhoto || defaultUserImage} title={e?.visitedByData?.personName || e?.visitedByDatas?.personName || e?.likedByData?.personName || e?.likeddByData?.personName || e?.ratingGivenByData?.personName || e?.ratingGivenByDatas?.personName || e?.pageFollowedBy?.personName || e.followedByuser?.personName} />
                                                                        </div>
                                                                        <div className='logo_details656'>
                                                                            <p>{e?.visitedByData?.personName || e?.visitedByDatas?.personName || e?.likedByData?.personName || e?.likeddByData?.personName || e?.ratingGivenByData?.personName || e?.ratingGivenByDatas?.personName || e?.pageFollowedBy?.personName || e?.followedByuser?.personName}</p>
                                                                            {
                                                                                e?.visitedByData?.companyName || e?.visitedByDatas?.companyName || e?.likedByData?.companyName || e?.likeddByData?.companyName || e?.ratingGivenByData?.companyName || e?.ratingGivenByDatas?.companyName || e?.pageFollowedBy?.companyName || e?.followedByuser?.companyName &&
                                                                                <span>{e?.visitedByData?.companyName || e?.visitedByDatas?.companyName || e?.likedByData?.companyName || e?.likeddByData?.companyName || e?.ratingGivenByData?.companyName || e?.ratingGivenByDatas?.companyName || e?.pageFollowedBy?.companyName || e?.followedByuser?.companyName}</span>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className='table_data_2'>
                                                                    {e?.profileLike ? "Liked your profile" : e?.pageLike ? "Liked your page" : e?.pageVisitor ? "Visited your page" : e?.pageRating ? "Rated your page" : e?.profileRating ? "Rated your page" : e?.pageFollow ? "Following your page" : "Visited your profile"}
                                                                </td>
                                                                <td className='table_data_3'>
                                                                    {formatDateAgo(e?.createdOn)}
                                                                </td>
                                                                <td className='table_data_4'>
                                                                    <div>
                                                                        <img src={e.visitedByData?.businessProfilePic || e.visitedByDatas?.businessProfilePic || e.likedByData?.businessProfilePic || e.likeddByData?.businessProfilePic || e.ratingGivenByData?.businessProfilePic || e.ratingGivenByDatas?.businessProfilePic || e.pageFollowedBy?.businessProfilePic || e?.followedByuser?.businessProfilePic || user} title={e?.visitedByData?.companyName || e?.visitedByDatas?.companyName || e?.likedByData?.companyName} alt={e?.visitedByData?.businessProfilePic || e?.visitedByDatas?.businessProfilePic || e?.likedByData?.businessProfilePic || e?.ratingGivenByData?.businessProfilePic | e?.ratingGivenByDatas?.businessProfilePic} style={{ maxHeight: "47px" }} />
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </>
                                                    )
                                                })
                                            }

                                            {
                                                activeInfoType === "total-members" && AnalyticsReportOverview.ConnectionData.filter(item => item?.visitedBy !== UserProfileID?._id && item?.likedBy !== UserProfileID?._id).sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn)).map((e, i) => {
                                                    return (
                                                        <>
                                                            <tr key={`ConnectionData-${i}`} style={{
                                                                borderBottom: ' 1px solid rgba(195, 195, 195, 1)'
                                                            }}>
                                                                <td className='table_data_1'>
                                                                    <div className='company_logo_details_Wrappper'
                                                                        style={{
                                                                            cursor: "pointer"
                                                                        }}
                                                                        onClick={(event) => handleBusinessPageView(event, e?.connectionWith)}
                                                                    >
                                                                        <div className='logo_img656'>
                                                                            <img src={e.connectionWith?.profilePhoto || defaultUserImage} title={e?.connectionWith?.personName} />
                                                                        </div>
                                                                        <div className='logo_details656'>
                                                                            <p>{e?.connectionWith?.personName}</p>
                                                                            {
                                                                                e?.connectionWith?.companyName &&
                                                                                <span>{e?.connectionWith?.companyName}</span>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className='table_data_2'>
                                                                    Connected with you
                                                                </td>
                                                                <td className='table_data_3'>
                                                                    {formatDateAgo(e?.createdOn)}
                                                                </td>
                                                                <td className='table_data_4'>
                                                                    <div>
                                                                        <img src={e.connectionWith?.businessProfilePic || user} title={e?.connectionWith?.companyName} alt={e?.connectionWith?.businessProfilePic} style={{ maxHeight: "47px" }} />
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}

export default AnalyticsReport
